"use client";
import { Box } from "@mui/material";
import { Inter } from "next/font/google";
import "./globals.css";
import { AppProvider } from "@/providers/AppProvider";
import env from "@/utils/config";
import Script from "next/script";

const inter = Inter({ subsets: ["latin"] });

export default function RootLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	process.env.NODE_ENV === "production" && (console.log = () => {});
	const siteName = env.PUBLIC_SITE_NAME;
	const titlePage = `${siteName} - ВПН надо - выбирай АВАДА`;

	const sx = {
		minHeight: "100vh",
		width: "100%",
		color: "text.primary",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
	};

	return (
		<html lang="ru" suppressHydrationWarning>
			<head>
				<title>{titlePage}</title>
				<meta
					name="description"
					content={`${siteName}. Устройство - 5 рублей в день. Высокая скорость. Youtube без рекламы.`}
				/>
				<meta property="og:title" content={siteName} />
				<meta
					property="og:description"
					content="ВПН надо - выбирай АВАДА! Устройство - 5 рублей в день. Высокая скорость. Youtube без рекламы."
				/>
				<meta property="og:url" content={env.PUBLIC_SITE_URL} />
				<meta property="og:type" content="website" />
                <Script 
                    src="https://telegram.org/js/telegram-web-app.js" 
                    strategy="beforeInteractive" 
                />
			</head>
			<body className={inter.className}>
				<AppProvider>
					<Box sx={sx}>{children}</Box>
				</AppProvider>
			</body>
		</html>
	);
}
